import type { ReactNode } from "react"

/** Label/value list for expanded rows; empty values are skipped. */
export function KeyValues({ pairs }: { pairs: [string, ReactNode][] }) {
  const shown = pairs.filter(([, value]) => value !== null && value !== undefined && value !== "")
  if (!shown.length) return null
  return (
    <dl className="hd-kv">
      {shown.map(([label, value]) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  )
}

export function ExternalLink({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

export const REPO_BLOB = "https://github.com/AIxCo/aix-turborepo/blob/develop"
